import { render, staticRenderFns } from "./feibiao.vue?vue&type=template&id=9c75dfba"
import script from "./feibiao.vue?vue&type=script&lang=js"
export * from "./feibiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports